import { RefObject } from 'react';
import { isBoolean } from 'lodash-es';
import { ClinicalBarData, ClinicalDataBars, ClinicalHeader } from '@features/components/ClinicalBarChart';
import { OrganType } from '@/api/apis/case';
import { yesNo } from '@/utils/helpers';

type LiverClinicalDataProps = {
  listItemRefs?: RefObject<(HTMLDivElement | null)[]>;
  listContainerRef?: RefObject<HTMLDivElement | null>;
  ocsPt: string;
  lactate?: ClinicalBarData[];
  bile?: boolean;
};

export const LiverClinicalData = ({
  lactate = [],
  bile,
  ocsPt,
  listContainerRef,
  listItemRefs,
}: LiverClinicalDataProps) => {
  return (
    <div className="flex flex-col w-full gap-1">
      <div className="flex justify-between items-center">
        <ClinicalHeader
          currentValue={lactate.at(-1)?.value}
          prevValue={lactate.at(-2)?.value}
          diffLabel="mmol/L"
          measurementUnits="(mmol/L)"
          parameter="Lactate"
          ocsTime={ocsPt}
        />
        {isBoolean(bile) && (
          <div className="flex flex-col items-end">
            <div className="text-s-r">Bile:</div>
            <div className="bg-green-90 rounded text-s-sb py-0.5 px-2">{yesNo(bile)} </div>
          </div>
        )}
      </div>
      <div ref={listContainerRef} className="w-full overflow-auto">
        <ClinicalDataBars
          listItemRefs={listItemRefs}
          cardView
          showLabel
          showValue
          values={lactate}
          organType={OrganType.Liver}
          verticalView={lactate.length > 3}
        />
      </div>
    </div>
  );
};
